export function authBasicHeader() {
    return { 'Authorization': 'Basic ' + process.env.REACT_APP_HEADER_BASIC };
    
}

